import { render, staticRenderFns } from "./text-templates-modal-basic-form-variables-area.vue?vue&type=template&id=e440f82c&scoped=true&"
import script from "./text-templates-modal-basic-form-variables-area.ts?vue&type=script&lang=ts&"
export * from "./text-templates-modal-basic-form-variables-area.ts?vue&type=script&lang=ts&"
import style0 from "./text-templates-modal-basic-form-variables-area.scss?vue&type=style&index=0&id=e440f82c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e440f82c",
  null
  
)

export default component.exports